enum Colors {
  blue700 = "#002369", //updated
  blue600 = "#002F8C", //updated
  blue500 = "#0441BC", //updated
  blue400 = "#1A79FF",
  blue300 = "#6A9BFC",
  blue200 = "#A6C3FF",
  blue100 = "#DAE6FF",
  blue000 = "#F1F6FF",
  grey900 = "#272D33", //updated
  grey800 = "#313840", //updated
  grey700 = "#3A434D", //updated
  grey600 = "#4E5966", //updated
  grey500 = "#687380", //updated
  grey400 = "#929BA6", //updated
  grey300 = "#C0C6CC", //updated
  grey200 = "#E0E3E6", //updated
  grey100 = "#EFF0F2", //updated
  grey000 = "#F5F6F7",
  white = "#FFFFFF",
  white80 = "#FFFFFFCC", //updated
  white40 = "#FFFFFF66", //updated
  white20 = "#FFFFFF33", //updated
  white10 = "#FFFFFF1A", //updated
  white05 = "#FFFFFF0D", //updated
  red700 = "#401010",
  red600 = "#8A2320",
  red500 = "#CC3931",
  red400 = "#FF5548",
  red300 = "#FF8678",
  red200 = "#FFBCB2",
  red100 = "#FFDFD9",
  red000 = "#FFF4F2", //updated
  green700 = "#083421",
  green600 = "#0D6248",
  green500 = "#139768",
  green400 = "#00BC77", //updated
  green300 = "#70D79B",
  green200 = "#ACF0C8",
  green100 = "#D6FCE6",
  green000 = "#EEFCF4",
  yellow700 = "#402E05",
  yellow600 = "#866109",
  yellow500 = "#C49012",
  yellow400 = "#F3B828",
  yellow300 = "#FFD25F",
  yellow200 = "#FFE9A7",
  yellow100 = "#FEF6D8",
  yellow000 = "#FEFCF4",
  midnight = "#03082E", //updated
  midnight80 = "#03082ECC", //updated
  midnight40 = "#03082E66", //updated
  midnight20 = "#03082E33", //updated
  midnight10 = "#03082E1A", //updated
  midnight05 = "#03082E0D", //updated
  background = "#F2F2F2", //what's this for? should we default to one of our grays?
  transparent = "transparent", //totally
  shadow = "#03082E4D",
  green40040percent = "#00BC7766", //updated
  yellow40040percent = "#F3B82866",
  red40040percent = "#FF554866",
}

export default Colors;
